import { BlogPost } from '@/types/blog';
import { content } from './content';

export const mythosNischePost: BlogPost = {
  title: 'Mythos "Nische": Warum moderne Führung Verbindung statt Spezialisierung braucht',
  metaTitle: 'Mythos Nische: Führung braucht Verbindung',
  date: '05.10.2025',
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  category: 'Führung & Organisation',
  tags: [
    'Scanner-Persönlichkeit',
    'Vielbegabung',
    'Positionierung',
    'Führung',
    'Neurodiversität',
    'Katalysator-Führung',
    'Expertise',
    'Generalist',
    'Mindful Leadership',
    'Tausendsassa',
    'Biophilie',
    'Naturverbindung',
    'Executive Coaching',
    'Neuroplastizität',
    'Epigenetik'
  ],
  excerpt: 'Ein Impuls für wache Menschen in bewegten Zeiten: Was, wenn die wertvollste Führungskompetenz nicht das Detail-Wissen ist, sondern das Verstehen komplexer Systeme? Eine wissenschaftlich fundierte Betrachtung von Katalysator-Führung.',
  imageUrl: '/lovable-uploads/mythos-nische-header.jpg',
  content,
  slug: 'mythos-nische',
  metaDescription: "Warum Scanner-Persönlichkeiten die besseren Führungskräfte für komplexe Systeme sind. Katalysator-Führung und vernetztes Denken.",
};
